import { useSuspenseQuery } from "@tanstack/react-query";

import { getUserTest } from "~/data/user-test/user-test.service";

export function useUserTest(id: string) {
  const { data } = useSuspenseQuery({
    queryKey: ["user_test", id],
    queryFn: () => getUserTest(id),
    staleTime: Infinity,
  });
  return data;
}
